import * as React from 'react';

import ConfirmDialog from 'components/ConfirmDialog';
import RemoveDeviceFromUserMutationContainer from 'settings/containers/RemoveDeviceFromUserMutationContainer';

type Props = {
  deviceId: number;
  deviceName: string;
  onRequestHide: () => void;
};

export default function RemoveDeviceFromUserConfirmDialog(props: Props) {
  return (
    <RemoveDeviceFromUserMutationContainer deviceName={props.deviceName}>
      {removeDevice => (
        <ConfirmDialog
          eventScreenName="UserEmailDevice"
          actionButtonText="Remove"
          cancelButtonText="Cancel"
          size="xsmall"
          glyph="caution"
          glyphColor="apple"
          title={`Remove ${props.deviceName}?`}
          subtext={`${props.deviceName} will no longer be associated with your account. You can always add it again!`}
          onConfirm={() => removeDevice({ variables: { input: props.deviceId } })}
          onRequestHide={props.onRequestHide}
        />
      )}
    </RemoveDeviceFromUserMutationContainer>
  );
}
